<template>
  <v-row justify="center">
    <v-dialog
        v-model="modalAddRekening"
        scrollable
        max-width="500px"
        v-on:close="toggleModalAddRekening()"
    >
      <v-card>
        <v-card-title>Tambah Rekening</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <br/>
          <v-alert
              dense
              outlined
              type="success"
          >
            Nomor Rekening akan di gunakan untuk tujuan disbursement modal, <strong>Nomor Rekening akan di verifikasi oleh admin terlebih dahulu</strong></v-alert>
          <br/>
          <v-select
              :items="codeBankList"
              label="Bank"
              :rules="rules"
              v-model="name"
          ></v-select>

          <br/>

          <v-text-field
              label="Nomor Rekening"
              :rules="rules"
              v-model="norek"
              hide-details="auto"
          ></v-text-field>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="grey darken-1"
              text
              v-on:click="toggleModalAddRekening()"
          >
            Close
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              v-on:click="[addRekening({ norek: norek, name:name }), resetForm()]"
          >
            Tambah
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";


export default {
  name: "ModalAddRekening",
  data: ()=>({
    rules: [
      value => !!value || 'Required.',
      value => (value || '').length <= 20 || 'Max 20 characters',
    ],
    norek: "",
    name: "",
    codeBankList: [
      "JABAR",
      "BPDDKI",
      "BPDDIY",
      "BPDJATENG",
      "BPDJATIM",
      "BPDJAMBI",
      "BPDACEHSYA",
      "BPDACEH",
      "BPDSUMUT",
      "BPDSUMBAR",
      "BPDRIAU",
      "BPDSUMSEL",
      "BPDLAMPUNG",
      "BPDKALSEL",
      "BPDKALBAR",
      "BPDKALTIMTARA",
      "BPDKALTENG",
      "BPDSULSELBAR",
      "BPDSULUTGO",
      "BPDNTBSYA",
      "BPDNTB",
      "BPDBALI",
      "BPDNTT",
      "BPDMALUKU",
      "BPDPAPUA",
      "BPDBENGKULU",
      "BPDSULTENG",
      "BPDSULTRA",
      "BPDBANTEN",
      "PARAHYANGAN",
      "SWADESI",
      "MUAMALAT",
      "MESTIKADHARMA",
      "METROEKS",
      "MASPIONINDO",
      "HAGAKITA",
      "GANESHA",
      "WINDUKENTJANA",
      "HALIM",
      "HARMONI",
      "QNB",
      "BTN",
      "HS1906",
      "JENIUS",
      "BTPN",
      "SWAGUNA",
      "BJBSYA",
      "BSM",
      "BISNISINT",
      "SRIPARTHA",
      "JASAJAKARTA",
      "BINTANGMANUNGGAL",
      "MNCINT",
      "YUDHABHAKTI",
      "MITRANIAGA",
      "AGRONIAGA",
      "INDOMONEX",
      "ROYALINDO",
      "ALFINDO",
      "MEGASYA",
      "INAPERDANA",
      "PANINSYA",
      "HARFA",
      "PRIMAMASTER",
      "PERSYARIKATANINDO",
      "SAMPOERNA",
      "AKITA",
      "LIMAN",
      "ANGLOMAS",
      "KESEJAHTERAANEKONOMI",
      "ARTOSINDO",
      "PURBADANARTA",
      "BTPNSYA",
      "MULTIARTA",
      "MAYORAINDO",
      "INDEXSELINDO",
      "EKSEKUTIF",
      "CENTRATAMA",
      "FAMA",
      "HARAPANBALI",
      "VICTORIA",
      "HARDA",
      "BPRKS",
      "AGRIS",
      "MERINCORP",
      "MAYBANKINDO",
      "OCBCINDO",
      "CTBC",
      "BI",
      "BRISYA",
      "BRI",
      "EXPORINDO",
      "MANDIRI",
      "BNISYA",
      "BNI",
      "DANAMON",
      "DANAMONSYA",
      "PERMATA",
      "PERMATASYA",
      "BCA",
      "MAYBANK",
      "MAYBANKSYA",
      "PANIN",
      "ARTANIAGA",
      "NIAGASYA",
      "NIAGA",
      "UOB",
      "LIPPO",
      "NISP",
      "AMEX",
      "CITIBANK",
      "JPMORGAN",
      "BANKOFAMERICA",
      "ING",
      "WINDUKENTJANAINT",
      "ARTHAGRAHA",
      "CAI",
      "BANGKOK",
      "HSBC",
      "HSBCSYA",
      "BANKOFTOKYO",
      "SUMITOMO",
      "DIGIBANK",
      "DBS",
      "RESONAPERDANIA",
      "MIZUHO",
      "STANDARDCHARTERED",
      "ABNAMRO",
      "KTB",
      "CAPITALINDO",
      "BNPPARIBAS",
      "UOBINDO",
      "KEBINDO",
      "RAPOBANK",
      "ANZ",
      "DEUTSCHE",
      "WOORI",
      "BANKOFCHINA",
      "BUMIARTA",
      "EKORAHARJA",
      "ANTARDAERAH",
      "HAGA",
      "IFI",
      "IFISYA",
      "CENTURY",
      "MAYAPADA",
      "BPDDKISYA",
      "BPDDIYSYA",
      "BPDKALSELSYA",
      "BPDKALTIMSYA",
      "SINARMAS",
      "BTNSYA",
      "JASAARTA",
      "MEGA",
      "BUKOPINSYA",
      "BUKOPIN",
      "BPR",
      "EKABUMIARTHA",
      "INDOSAT",
      "PTBC",
      "TCASH"
    ]
  }),
  computed: {
    ...mapState('Bayartempo',['modalAddRekening'])
  },
  methods: {
      resetForm() {
        this.name = "";
        this.norek = "";
      },
    ...mapActions('Bayartempo',['toggleModalAddRekening','addRekening']),
  }
}
</script>

<style scoped>

</style>